import { Box } from '@mui/material'

export const Footer = ({ basicInfo }) => {
	const {name, copywright} = basicInfo;
	return (
		<Box component="footer" sx={footerStyles}>{name} &copy; {copywright}</Box>
	)
}

const footerStyles = {
	opacity: 0.7,
	fontSize: '13px',
	textAlign: 'right',
	margin: 0,
	padding: '15px',
	color: '#657786',
	borderTop: '1px solid #e1e8ed',
	'@media (max-width: 768px)': {
		margin: 0,
		padding: '10px',
	},
};
